var map = {
	"./audi.PNG": 5749,
	"./bmw.PNG": 2950,
	"./chery.PNG": 4269,
	"./citroen.PNG": 9452,
	"./default.PNG": 2079,
	"./fiat.PNG": 30,
	"./ford.PNG": 9593,
	"./gm.PNG": 330,
	"./hyundai.PNG": 8206,
	"./jeep.PNG": 2574,
	"./kia.PNG": 1417,
	"./mercedes.PNG": 7949,
	"./mitsubishi.PNG": 1151,
	"./nissan.PNG": 4102,
	"./peugeot.PNG": 7203,
	"./renault.PNG": 8929,
	"./toyota.PNG": 1660,
	"./volkswagen.PNG": 5899,
	"./volvo.PNG": 3042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4511;